
export default {
    name: 'GoodsUpload',
    props: {
        imgUrl: {
            type: String,
            default: ''
        },
        altImg: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 商品图片
            imageUrl: '',
            coverLayerStyle: {
                transform: '',
                left: '0px',
                top: '0px',
                width: null,
                height: null
            },
            coverLayerImg: {
                width: null,
                height: null,
                transform: ''
            },
            backgroundPosition: '0 0',
            backgroundSize: '0 0',
            coverLayerShow: false
        }
    },
    mounted() {
        const _width = this.$refs.imageBox.offsetWidth * 3 + 'px'
        const _height = this.$refs.imageBox.offsetHeight * 3 + 'px'
        this.backgroundSize = `${_width} ${_height}`
        // this.coverLayerImg.width = _width;
        // this.coverLayerImg.height = _height;
        this.coverLayerStyle.width = this.$refs.imageBox.offsetWidth / 3 + 'px'
        this.coverLayerStyle.height = this.$refs.imageBox.offsetHeight / 3 + 'px'
    },
    methods: {
        // 鼠标进入原图空间函数
        enterHandler() {
            // 层罩及放大空间的显示
            this.coverLayerShow = true
        },
        // 鼠标移动函数
        moveHandler(event) {
            //
            // 鼠标的坐标位置
            let x = event.offsetX
            let y = event.offsetY

            const offsetWidth = this.$refs.imageBox.offsetWidth
            const offsetHeight = this.$refs.imageBox.offsetHeight
            //
            // 层罩的左上角坐标位置，并对其进行限制：无法超出原图区域左上角
            let topX = x - offsetWidth / 3 / 2 < 0 ? 0 : x - offsetWidth / 3 / 2
            let topY = y - offsetHeight / 3 / 2 < 0 ? 0 : y - offsetHeight / 3 / 2
            // 对层罩位置再一次限制，保证层罩只能在原图区域空间内
            if (topX < 0) {
                topX = 0
            } else if (topX > offsetWidth - offsetWidth / 3) {
                topX = offsetWidth - offsetWidth / 3
            }
            if (topY < 0) {
                topY = 0
            } else if (topY > offsetHeight - offsetHeight / 3) {
                topY = offsetHeight - offsetHeight / 3
            }
            // 通过 transform 进行移动控制
            this.coverLayerStyle.transform = `translate(${topX}px,${topY}px)`
            //   this.coverLayerStyle.left = topX + "px";
            //   this.coverLayerStyle.top = topY + "px";
            //   this.coverLayerImg.transform = `translate(-${3 * x - x}px,-${
            //     3 * y - y
            //   }px)`;
            this.backgroundPosition = `-${3 * topX}px  -${3 * topY}px`
        },
        // 鼠标移出函数
        outHandler() {
            // 控制层罩与放大空间的隐藏
            this.coverLayerShow = false
        }
    }
}
